<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'printerList'}">
            打印机列表
          </router-link>
        </li>
        <li class="active">添加/更新</li>
      </ol>
    </div>
    <div class="content-from">
      <el-row>
        <el-col>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>打印机基本信息</span>
            </div>
            <div class="text item">
              <el-form ref="formName" :model="saveModel" label-width="120px" :rules="rules">
                <el-form-item label="设备名称:" prop="name">
                  <el-input v-model="saveModel.name" placeholder="打印机名称"></el-input>
                </el-form-item>
                <el-form-item label="设备编号:" prop="deviceCode">
                  <el-input v-model="saveModel.deviceCode" placeholder="设备编号"></el-input>
                </el-form-item>
                <el-form-item label="设备秘钥:" prop="deviceKey">
                  <el-input v-model="saveModel.deviceKey" placeholder="设备秘钥"></el-input>
                </el-form-item>
                <el-form-item label="所属仓库:" prop="outletsId">
                  <el-select clearable v-model="saveModel.outletsId">
                    <el-option v-for="item in outlets" :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="启用设备:" prop="status">
                  <el-switch
                      v-model="saveModel.status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="ENABLE"
                      inactive-value="DISABLE">
                  </el-switch>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div style=" text-align: center;">
            <el-button @click="$router.back(-1)">返回</el-button>
            <el-button type="primary" @click="saveGoods()">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      saveModel: {
        name: '',
        deviceCode: '',
        deviceKey: '',
        status: 'ENABLE',
        outletsId: '',
      },
      outlets: [],
      rules: {
        name: [
          {required: true, message: '请输入设备名称', trigger: 'blur'},
        ],
        deviceCode: [
          {required: true, message: '请输入设备编号', trigger: 'blur'}
        ],
        deviceKey: [
          {required: true, message: '请输入设备秘钥', trigger: 'blur'}
        ],
        outletsId: [
          {required: true, message: '请选择关联网点', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '请选择设备状态', trigger: 'blur'}
        ],
      }
    }
  },
  mounted() {
    this.saveModel.id = this.$route.query.id;
    if (this.saveModel.id) {
      this.detailPrinter();
    }
  },
  created() {
    this.pageOutlets();
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    pageOutlets() {
      this.$common.my_ajax({
        url: 'seller/pageSeller',
        data: {
          limit: -1,
        },
        success: (response) => {
          this.outlets = response.items;
        }
      });
    },
    detailPrinter() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'printer/detailPrinter',
        data: {
          printerId: _this.saveModel.id,
          type: 1,
        },
        success: function (response) {
          _this.saveModel = response.item;
        }
      });
    },
    saveGoods() {
      var _this = this;
      _this.$refs['formName'].validate((valid) => {
        if (valid) {
          _this.$common.my_ajax({
            url: 'printer/savePrinter',
            data: _this.saveModel,
            success: function (response) {
              _this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000,
                onClose: function () {
                  _this.$router.back(-1);
                }
              });
            }
          });
        } else {
          return false;
        }
      });
    },

  }
}
</script>

<style scoped>
.col-sm-3 {
  width: 20%;
}

.property-box {
  width: auto !important;
  max-width: 678px;
}

.can-shu {
  width: 160px;
  margin-bottom: 20px;
}

.steps {
  padding: 20px;
  margin: 20px;
}

.box-card {
  width: 75%;
  margin: 0 auto;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
